module.exports = __webpack_public_path__ + "img/greyUp.dd7a6bdc.svg";